import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Smartphone, Tablet, Monitor } from 'lucide-react';

interface DevicePreviewProps {
  children: React.ReactNode;
}

export const DevicePreview: React.FC<DevicePreviewProps> = ({ children }) => {
  const [deviceType, setDeviceType] = useState<'desktop' | 'tablet' | 'mobile'>('desktop');
  
  const getDeviceStyles = () => {
    switch (deviceType) {
      case 'mobile':
        return { 
          width: '375px',
          height: '667px',
          transform: 'scale(0.75)',
          transformOrigin: 'top center'
        };
      case 'tablet':
        return { 
          width: '768px',
          height: '1024px',
          transform: 'scale(0.5)',
          transformOrigin: 'top center'
        };
      case 'desktop':
      default:
        return { 
          width: '100%',
          maxWidth: '1200px',
          height: 'auto',
          minHeight: '600px'
        };
    }
  };
  
  return (
    <div className="flex flex-col items-center">
      <Tabs 
        value={deviceType} 
        onValueChange={(value) => setDeviceType(value as 'desktop' | 'tablet' | 'mobile')}
        className="mb-4"
      >
        <TabsList>
          <TabsTrigger value="desktop" className="flex items-center gap-1">
            <Monitor className="h-4 w-4" />
            <span className="hidden sm:inline">Desktop</span>
          </TabsTrigger>
          <TabsTrigger value="tablet" className="flex items-center gap-1">
            <Tablet className="h-4 w-4" />
            <span className="hidden sm:inline">Tablet</span>
          </TabsTrigger>
          <TabsTrigger value="mobile" className="flex items-center gap-1">
            <Smartphone className="h-4 w-4" />
            <span className="hidden sm:inline">Mobile</span>
          </TabsTrigger>
        </TabsList>
      </Tabs>
      
      <div className="relative w-full flex justify-center overflow-auto">
        <div
          className={`${
            deviceType === 'desktop' ? '' : 'border-8 border-gray-800 rounded-xl overflow-hidden'
          } transition-all duration-300 bg-white`}
          style={getDeviceStyles()}
        >
          {deviceType !== 'desktop' && (
            <div className="w-full h-6 bg-gray-800 flex items-center justify-center">
              <div className="w-16 h-1 bg-gray-600 rounded-full"></div>
            </div>
          )}
          <div 
            className={`overflow-auto ${deviceType !== 'desktop' ? 'border-t border-gray-300' : ''}`}
            style={{ 
              height: deviceType === 'desktop' ? 'auto' : deviceType === 'tablet' ? '1000px' : '635px'
            }}
          >
            {children}
          </div>
          {deviceType !== 'desktop' && (
            <div className="w-full h-10 bg-gray-800 flex items-center justify-center">
              <div className="w-10 h-10 rounded-full border-2 border-gray-600"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 